<template>
    <div class="w-full">
        <div class="relative"
             @dragover.prevent="dragover = true"
             @dragleave.prevent="dragover = false"
             @drop.prevent="onDrop">
            
            <input type="file" 
                   ref="fileInput"
                   multiple
                   class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                   @change="onChange">
            
            <div class="w-full p-4 border-2 border-dashed rounded-lg transition-colors duration-200"
                 :class="[dragover ? 'border-indigo-400 bg-indigo-50' : 'border-gray-300 bg-gray-50 hover:border-gray-400']">
                <div class="flex flex-col items-center justify-center space-y-2">
                    <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <div class="text-center">
                        <p class="text-sm text-gray-600">
                            <span class="font-medium text-indigo-600 hover:text-indigo-500">
                                Click to upload
                            </span>
                            or drag and drop
                        </p>
                        <p class="mt-1 text-xs text-gray-500" v-if="selectedFiles.length">
                            Selected: {{ selectedFiles.length }} file(s)
                        </p>
                        <p class="mt-1 text-xs text-gray-500" v-else>
                            Any file type accepted
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dragover: false,
                selectedFiles: []
            }
        },
        methods: {
            onChange(e) {
                if (!e.target.files.length) return;
                this.handleFiles(Array.from(e.target.files));
            },
            onDrop(e) {
                this.dragover = false;
                if (!e.dataTransfer.files.length) return;
                this.handleFiles(Array.from(e.dataTransfer.files));
            },
            handleFiles(files) {
                this.selectedFiles = files;
                files.forEach(file => {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = e => {
                        let src = e.target.result;
                        this.$emit('loaded', { src, file });
                    };
                });
            }
        }
    }
</script>